var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z",
    fill: "#106C3A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6905_2980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.375 17.7521V12.1875C33.375 11.8716 33.2491 11.57 33.0282 11.3467C32.8074 11.1235 32.5034 11 32.1875 11H15.5625C14.907 11 14.375 11.532 14.375 12.1875V17.7521C14.375 20.6069 15.4865 23.2906 17.5053 25.3094L19.8209 27.625L17.5053 29.9406C15.4865 31.9618 14.375 34.6431 14.375 37.4979V43.0649C14.375 43.3808 14.5009 43.6824 14.7218 43.9056C14.9426 44.1289 15.2466 44.2524 15.5625 44.2524L32.1875 44.25C32.843 44.25 33.375 43.718 33.375 43.0625V37.4955C33.375 34.6408 32.2635 31.957 30.2448 29.9382L27.9291 27.625L30.2448 25.307C32.2635 23.2906 33.375 20.6069 33.375 17.7521Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 13.375C12.532 13.375 12 12.8454 12 12.1875C12 11.5344 12.532 11 13.1875 11H34.5625C35.218 11 35.75 11.532 35.75 12.1875C35.75 12.843 35.218 13.375 34.5625 13.375H13.1875Z",
    fill: "#B6C4BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5625 44.25H13.1875C12.5344 44.25 12 43.7156 12 43.0625C12 42.4094 12.5344 41.875 13.1875 41.875H34.5625C35.2156 41.875 35.75 42.4094 35.75 43.0625C35.75 43.7156 35.2156 44.25 34.5625 44.25Z",
    fill: "#B6C4BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 15.75V17.7521C16.75 19.9727 17.6145 22.058 19.1844 23.6302C19.1844 23.6302 23.875 27.3115 23.875 27.625C23.875 27.3115 28.5656 23.6279 28.5656 23.6279C30.1355 22.058 31 19.9704 31 17.7521V15.75H16.75Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 41.875V39.8729C16.75 37.6522 17.6145 35.567 19.1844 33.9948C19.1844 33.9971 23.875 30.3135 23.875 30C23.875 30.3135 28.5656 33.9971 28.5656 33.9971C30.1355 35.567 31 37.6546 31 39.8752V41.875H16.75Z",
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5625 41.8741H33.375V37.4946C33.375 34.6399 32.2635 31.9561 30.2448 29.9374L29.7484 29.4434C27.5848 31.7756 26.25 34.8869 26.25 38.3116C26.25 40.4515 26.7772 42.4655 27.6916 44.2491H32.1875H34.5625C35.2156 44.2491 35.75 43.7147 35.75 43.0616C35.75 42.4085 35.2156 41.8741 34.5625 41.8741Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3125 49C45.215 49 50 44.215 50 38.3125C50 32.41 45.215 27.625 39.3125 27.625C33.41 27.625 28.625 32.41 28.625 38.3125C28.625 44.215 33.41 49 39.3125 49Z",
    fill: "#A5CC46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.875 43.0625C42.571 43.0625 42.267 42.9461 42.0342 42.7157L38.4717 39.1533C38.2509 38.93 38.125 38.6284 38.125 38.3125V33.5625C38.125 32.907 38.657 32.375 39.3125 32.375C39.968 32.375 40.5 32.907 40.5 33.5625V37.8209L43.7157 41.0366C44.1789 41.4998 44.1789 42.2526 43.7157 42.7157C43.483 42.9461 43.179 43.0625 42.875 43.0625Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6905_2980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sandClock.26a44af88f6e8be9ad46aa0feaf2c89e.svg";
export { ForwardRef as ReactComponent };